import { render } from "./VUEPopupStazioneMeteo.vue?vue&type=template&id=ec61fbd4"
import script from "./VUEPopupStazioneMeteo.vue?vue&type=script&lang=js"
export * from "./VUEPopupStazioneMeteo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__